const initCarousel = () => {
  const carouselContainer = document.querySelector(
    '[data-carousel="container"]'
  )
  const carouselGrid = document.querySelector('[data-carousel="grid"]')
  const carouselGridWidth = 1160
  const carouselGridItems = [].slice.call(
    document.querySelectorAll('[data-carousel="grid-item"]')
  )
  const carouselGridItemWidth = carouselGridWidth / carouselGridItems.length
  const carouselTicks = [].slice.call(
    document.querySelectorAll('[data-carousel="tick-item"]')
  )
  let scrollPos = 0

  carouselContainer.setAttribute(
    'style',
    'overflow-x: auto; -webkit-overflow-scrolling: touch;'
  )
  carouselGrid.setAttribute('style', `width: ${carouselGridWidth}px;`)

  carouselGridItems.forEach(gridItem => {
    gridItem.setAttribute(
      'style',
      `width: ${carouselGridItemWidth}px !important; flex-basis: auto;`
    )
  })

  carouselContainer.addEventListener('scroll', () => {
    scrollPos = carouselGrid.getBoundingClientRect().left

    if (scrollPos >= -(carouselGridItemWidth / 2)) {
      removeTickState(carouselTicks)
      carouselTicks[0].classList.add('--is-active')
    } else if (
      scrollPos >
      -carouselGridItemWidth + -(carouselGridItemWidth / 2)
    ) {
      removeTickState(carouselTicks)
      carouselTicks[1].classList.add('--is-active')
    } else if (
      scrollPos >
      -carouselGridItemWidth * carouselGridItems.length +
        -(carouselGridItemWidth / 2)
    ) {
      removeTickState(carouselTicks)
      carouselTicks[2].classList.add('--is-active')
    }
  })
}

const removeTickState = ticks => {
  ticks.forEach(function(tickItem) {
    tickItem.classList.remove('--is-active')
  })
}

if (window.innerWidth <= 768) {
  initCarousel()
}
